import { jQuery } from './utils/jquery.js';
import niceSelectPlugin from './vendors/jquery-nice-select.js';
import { Swiper, Navigation, Pagination } from 'swiper';
import { Fancybox } from "@fancyapps/ui";

niceSelectPlugin(jQuery);

function layoutFreeze() {
  const h = jQuery("html");

  if (h.css("position") !== "fixed") {
    const top = h.scrollTop() ? h.scrollTop() : jQuery("body").scrollTop();

    if (window.innerWidth > h.width()) {
      h.css("overflow-y", "scroll");
    }

    h.css({
      position: "fixed",
      top: -top,
    });
  }
}

function layoutUnfreeze() {
  const h = jQuery("html");

  if (h.css("position") === "fixed") {
    h.css("position", "static");

    jQuery("html, body").scrollTop(-parseInt(h.css("top"), 10));
    h.css({
      position: "",
      top: "",
      "overflow-y": "",
    });
  }
}

/**
 * site_preloader_on
 */
function site_preloader_on(msg) {
  if (typeof msg == "undefined" || !msg) {
    msg = "Please wait..";
  }
  jQuery("body")
    .addClass("processing")
    .block({
      message: msg,
      overlayCSS: {
        background: "#fff",
        opacity: 0.6,
      },
    });
}

/**
 * site_preloader_off
 */
function site_preloader_off() {
  jQuery("body").removeClass("processing").unblock();
}

jQuery(function ($) {
  // caProduct: custom attribute product
  var caProduct = {
    selected_pair: {},
    selectedCurrentVariant: {},
    doProcessForProductRedirectAndOptionsRequests: null,
    doProcessForProductRedirectAndOptions: function (ajaxData) {
      ajaxData["action"] = "wagt_get_custom_attribute_product_options"; // ajax action

      caProduct.doProcessForProductRedirectAndOptionsRequests = jQuery.ajax({
        type: "post",
        url: wc_add_to_cart_params.ajax_url,
        data: ajaxData,
        beforeSend: function () {
          if (caProduct.doProcessForProductRedirectAndOptionsRequests != null) {
            caProduct.doProcessForProductRedirectAndOptionsRequests.abort();
          }
          site_preloader_on();
        },
        complete: function (response) {},
        success: function (response) {
          site_preloader_off();
          if (response.succ) {
            if (typeof response.redirect != "undefined" && response.redirect) {
              window.location.href = response.redirect;
            } else {
              // append and
              jQuery(response.attribute_selects).each(function (
                eachSelectID,
                eachValue
              ) {
                let selectEl = jQuery("#" + eachValue.select_id);
                if (selectEl.length) {
                  selectEl.replaceWith(eachValue.html);
                }
              });
            }
          }
        },
      });
    },
  };
  // Custom attribute product js
  jQuery(document).on(
    "click",
    ".js-custom-attribute-product-option",
    function () {
      let selectBoxElId = jQuery(this).attr("data-select-id");
      let attributeValue = jQuery(this).attr("data-option-value");
      let attributeType = jQuery(this).attr("data-attribute-type");
      let attributeSlug = jQuery(this).attr("data-attribute-slug");
      caProduct.selectedCurrentVariant = {
        selected_attribute_id: attributeValue,
        selected_attribute_type: attributeType,
      };

      if (typeof caProduct.selected_pair[attributeSlug] != "undefined") {
        delete caProduct.selected_pair[attributeSlug];
      }

      caProduct.selected_pair[attributeSlug] = caProduct.selectedCurrentVariant;
      let ajaxData = {};
      ajaxData["selected_pair"] = caProduct.selected_pair;
      ajaxData["selectedCurrentVariant"] = caProduct.selectedCurrentVariant;
      ajaxData["foundSeriesInProduct"] = window["foundSeriesInProduct"];

      caProduct.doProcessForProductRedirectAndOptions(ajaxData);
    }
  );
});

jQuery(function ($) {
  // init nice select
  if (jQuery("select.wagt-nice-select").length) {
    jQuery("select.wagt-nice-select").niceSelect();
  }
  // End init nice select

  // share cart events
  jQuery(document).off("click", ".wpcss-btn");
  jQuery(document).off("touch", ".wpcss-btn");
  jQuery(document).on(
    "click touch",
    ".wpcss-btn, .js-side-cart-share-cart-btn",
    function (e) {
      e.preventDefault();
      site_preloader_on();
      var hash = jQuery(this).data("hash");
      jQuery(this).removeClass("wpcss-added").addClass("wpcss-adding");
      var data = {
        action: "wpcss_share",
        hash: hash,
        nonce: wpcss_vars.nonce,
      };

      jQuery.post(wpcss_vars.ajax_url, data, function (response) {
        site_preloader_off();
        jQuery(".wpcss-btn")
          .removeClass("wpcss-adding")
          .addClass("wpcss-added");
        jQuery(".wpcss-popup-content").html(response);
        setTimeout(function () {
          let shareURl = jQuery(document).find("#wpcss_copy_url").val();
          jQuery(document).find("#wagt-cart-share-url").val(shareURl);
          jQuery(document).find("#wagt-cart-share-url").attr("value", shareURl);
          Fancybox.show([{ src: "#share-my-cart-popup", type: "inline" }]);
        });
      });
    }
  );
  jQuery(document).on(
    "click touch",
    ".js-share-my-cart-popup__form_wrap form",
    function () {
      let shareCartURL = jQuery(document).find("#wagt-cart-share-url").val();
      jQuery("body").append('<input id="copyURL" type="text" value="" />');
      jQuery("#copyURL").val(shareCartURL).select();
      document.execCommand("copy");
      jQuery("#copyURL").remove();
      alert(wpcss_vars.copied_text.replace("%s", shareCartURL));
    }
  );
  jQuery(document).on("click touch", ".js-wagt-share-my-cart", function () {
    jQuery(".wpcss-btn").trigger("click");
  });

  if (jQuery('.js-wagt-login-form').length > 0) {
    jQuery(document).on("click touch", ".js-wagt-login-form", function (e) {
      e.preventDefault();
      Fancybox.show([{ 
        src: "#login-form-popup", 
        type: "inline",
      }]);
    });
  }

  // End shae cart events

  // manage remove from cart alert
  jQuery(document).on("click", ".wagt-cart-item-remove", function () {
    event.preventDefault();
    let alertWrapperIndex = jQuery(this).data("alert-wrapper");
    let alertWrapperEl = jQuery("#" + alertWrapperIndex);
    alertWrapperEl.fadeIn();
  });
  // when click "NO" button
  jQuery(document).on("click", ".js-wagt-remove-from-cart", function (e) {
    e.preventDefault();
    let alertWrapperIndex = jQuery(this).data("alert-wrapper");
    let alertWrapperEl = jQuery("#" + alertWrapperIndex);

    let delIemClass = jQuery(this).data("remove-class");
    let delIemClassEl = jQuery("." + delIemClass);

    // trigger delete for actual cart item index
    delIemClassEl.trigger("click");
  });

  // When user click keep in basket the skip remove from cart step
  jQuery(document).on("click", ".js-skip-remove-form-cart", function () {
    event.preventDefault();
    let alertWrapperIndex = jQuery(this).data("alert-wrapper");
    let alertWrapperEl = jQuery("#" + alertWrapperIndex);
    alertWrapperEl.hide();
  });
  // end manage remove from cart alert

  jQuery(document).on("click", ".js-add-cart-item-to-wishlist", function () {
    let data = {};
    let productImage = jQuery(this).data("product-image");
    data.action = "woocommerce_wagt_ajax_add_to_wishlist"; // ajax action
    data.product_id = jQuery(this).data("product-id");
    let delIemClass = jQuery(this).data("remove-class");
    let delIemClassEl = jQuery("." + delIemClass);

    jQuery.ajax({
      type: "post",
      url: window["wagt_ajax_url"],
      data: data,
      beforeSend: function (response) {
        site_preloader_on();
      },
      complete: function (response) {
        site_preloader_off();
      },
      success: function (response) {
        if (response.succ) {
          wishlistInstance.changeModalProductImage(productImage); // change image
          wishlistInstance.wishlistSuccessPopupEl
            .removeClass("removed")
            .addClass("added");
          Fancybox.show([{ 
            src: "#pop-wishlist-step-2", 
            type: "inline",
          }]);

          setTimeout(function() {
              window.location.href = delIemClassEl.attr('href');
          }, 1000);
          
        } else {
          // show error
          alert(response.errors_string);
          return false;
        }
      },
    });
    return false;
  });

  // manage my account active navigation class
  let activeMyAccountURL = window.location.href;
  if (jQuery(".nx-myaccount-menu__menu-wrap").length) {
    jQuery(".nx-myaccount-menu__menu-wrap a").each(function (index, each) {
      let url = jQuery(this).attr("href");
      if (url === activeMyAccountURL) {
        jQuery(this).addClass("active");
        jQuery(this).parent().addClass("active");
      }
    });
  }
  // End manage my account active navigation class

  // bind toggle events
  jQuery(document).on(
    "click",
    ".bk-js-product-options__active-item",
    function () {
      jQuery(this).find("+ div").slideToggle();
    }
  );
});

// Map key up event on cart page - in gift card msg
jQuery(document).on(
  "keyup change copy paste",
  ".wagt-record-my-message-form .enterText",
  function () {
    showRemainingChar(this, "js-gift-card-msg-count", 250);
    let thisVAl = jQuery(this).val();
    let sideCardGiftMsgEl = jQuery(document).find(".js-sidebar-gift-msg");
    sideCardGiftMsgEl.val(thisVAl);
    sideCardGiftMsgEl.html(thisVAl);
  }
);

jQuery(document).on(
  "keyup change copy paste",
  ".js-sidebar-gift-msg",
  function () {
    let thisVal = jQuery(this).val();
    let cartPageGiftMsgForm = jQuery(".wagt-record-my-message-form .enterText");
    if (cartPageGiftMsgForm.length) {
      cartPageGiftMsgForm.val(thisVal);
      cartPageGiftMsgForm.html(thisVal);
    }
  }
);

function triggerCartPageGiftCardMsgInput() {
  jQuery(document).find(".js-cart-page-gift-card-msg").trigger("keyup");
}

jQuery('.header__cart').on('click', function() {
  showSideCartModal()
});

function showSideCartModal() {
  const cartContainer = jQuery(".right-cart");

  cartContainer.show(0, function () {
    jQuery(this)
      .css({ display: "flex", position: "fixed" })
      .addClass("is-active");
  });

  layoutFreeze();

  // Gift card show if not empty
  const giftMessageInput = cartContainer.find(".js-gift-message-input");

  if (giftMessageInput.val()) {
    giftMessageInput.trigger("display-remaining-char-count");

    if (!cartContainer.find(".js-gift-message-form").hasClass("is-active")) {
      cartContainer.find(".js-cart-gift-textarea-trigger").click();
    }
  }
}

jQuery(document).on("click", ".init-cart", showSideCartModal);
jQuery(document).on("added_to_cart", showSideCartModal);
jQuery(document).on("click", ".js-close-cart", () => {
  const cartContainer = jQuery(".right-cart");

  cartContainer.removeClass("is-active");

  layoutUnfreeze();

  setTimeout(() => {
    cartContainer.hide();
  }, 1000);
});

// Apply coupon
function wagt_apply_coupon(formID) {
  event.preventDefault();
  let formEl = jQuery("#" + formID);
  let errorCodeEl = formEl.find(".form-error-notes");
  jQuery.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: formEl.serialize(),
    dataType: "html",
    beforeSend: function () {
      site_preloader_on();
      errorCodeEl.html("").hide();
    },
    success: function (response) {
      site_preloader_off();
      formEl.find("input[name=coupon_code]").val("");
      errorCodeEl.html(response).fadeIn();
      setTimeout(function () {
        jQuery(document.body).trigger("wc_fragment_refresh");
      }, 2000);
    },
  });
}

// end apply coupon

// Record my message
function showRemainingChar(val, classNameWhereToShow, countLength) {
  let len = val.value.length;
  if (typeof countLength == "undefined" || !countLength) {
    countLength = 250;
  }
  let showCountIn = jQuery(document).find("." + classNameWhereToShow);
  if (len >= countLength) {
    val.value = val.value.substring(0, countLength);
  } else {
    showCountIn.text(countLength - len);
  }
}

function recordMyGiftMessage(e) {
  e.preventDefault();

  const form = jQuery(e.target);
  const giftMsgEl = form.find('textarea[name="message"]');
  const giftMsg = giftMsgEl.val();
  const errorCodeEl = form.find(".gift-message-form__error");

  function resetError() {
    form.removeClass("has-error");
    errorCodeEl.text("").removeClass("woocommerce-error woocommerce-success");
  }

  function setError(text, success = false) {
    form.addClass("has-error");
    errorCodeEl
      .text(text)
      .addClass(success ? "woocommerce-success" : "woocommerce-error");
  }

  jQuery.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: form.serialize(),
    dataType: "json",
    beforeSend: function () {
      site_preloader_on();
      resetError();
    },
    success: function (response) {
      site_preloader_off();
      const responseEl = jQuery(response.html);
      setError(responseEl.text(), Boolean(response.succ));

      if (jQuery("body").hasClass("woocommerce-checkout")) {
        jQuery('input[name="wagt_gift_card_msg"]').val(giftMsg);
      }
    },
  });
}

jQuery(document).on("submit", ".js-gift-message-form", recordMyGiftMessage);

// end Record my message

// Start our artist page js

jQuery(function () {
  let artistPageID = parseInt(window["option_our_artist_page"]);
  if (
    typeof artistPageID == "undefined" ||
    artistPageID == null ||
    !artistPageID
  ) {
    return;
  }

  if (!jQuery("body").hasClass("page-id-" + artistPageID)) {
    return false;
  }

  var ourArtistInstance = {
    per_page_results: 10,
    defaultFilters: {
      limit: this.per_page_results,
      page: 1,
      order: "ASC",
    },
    ajaxQueue: null,
    swiperInstance: null,
    initSwiper: function () {
      // if already init then destroy
      if (this.swiperInstance != null) {
        this.swiperInstance.destroy();
      }

      this.swiperInstance = new Swiper(".artists-product-slider", {
        modules:[Navigation, Pagination],
        pagination: {
          el: ".artists-product-slider__swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    getArtists: function (formData) {
      if (
        typeof formData === "undefined" ||
        Object.keys(formData).length === 0
      ) {
        formData = {};
      }
      formData["action"] = "wagt_ajax_our_artists";
      let categoryGridWrapper = jQuery(".js-artists-grid");
      let preloaderWrapper = jQuery(".js-artists-grid-preloader-wrapper");
      let noResultsFoundWrapper = jQuery(
        ".js-artists-no-results-found-wrapper"
      );
      let paginationWrapper = jQuery(".js-artists-pagination");

      this.ajaxQueue = jQuery.ajax({
        url: window["wagt_ajax_url"],
        dataType: "json",
        beforeSend: function () {
          // abort | kill old request`
          if (ourArtistInstance.ajaxQueue != null) {
            ourArtistInstance.ajaxQueue.abort();
          }

          // run preloader and do empty grid wrapper
          preloaderWrapper.show(); // show preloader
          categoryGridWrapper.hide(); // hide grid
          noResultsFoundWrapper.hide(); // hide not found
          paginationWrapper.hide();
        },
        data: formData,
        success: function (res) {
          // set sorting
          jQuery(
            'button[data-sort-value="' + formData["order"] + '"]'
          ).addClass("is-active");

          preloaderWrapper.hide();
          // show pagination
          if (res.pagination) {
            paginationWrapper.html(res.pagination).show();
          }

          if (res.our_artists_html) {
            // append data into grid wrapper
            categoryGridWrapper.html(res.our_artists_html).show();
            ourArtistInstance.initSwiper();
          } else {
            // when no results found
            categoryGridWrapper.hide();
            noResultsFoundWrapper.show();
          }
        },
      });
    },
  };

  // on ready state
  let formData = ourArtistInstance.defaultFilters;
  ourArtistInstance.getArtists(formData);
  // end ready state

  let dropdownEl = jQuery(".js-select-artists");
  dropdownEl.select2({
    placeholder: "mon artiste préféré",
    ajax: {
      url: window["wagt_ajax_url"],
      dataType: "json",
      data: function (params) {
        return {
          name__like: params.term, // search key
          limit: 20,
          action: "wagt_ajax_our_artists_for_dropdown",
        };
      },
      processResults: function (data) {
        return {
          results: data.items,
        };
      },
    },
  });
  dropdownEl.one("select2:open", function (e) {
    jQuery("input.select2-search__field").prop(
      "placeholder",
      "Rechercher un artiste"
    );
  });
  dropdownEl.val("").trigger("change");

  jQuery(document).on("change", ".js-select-artists", function () {
    let thisVal = jQuery(this).val();
    if (typeof thisVal != "undefined" && thisVal) {
      window.location.href = thisVal;
    }
  });

  // Manage event on pagination link
  jQuery(document).on("click", ".js-artists-pagination a", function () {
    event.preventDefault();
    let paginateURl = jQuery(this).attr("href");
    let urlArgs = paginateURl.split("&paged=");
    let ajaxFilter = {
      limit: ourArtistInstance.per_page_results,
      page: urlArgs[1],
    };
    ourArtistInstance.getArtists(ajaxFilter);
  });
  // End Manage event on pagination link

  // manage our artist sorting filter
  jQuery(document).on("click", ".js-our-artist-sort-filter", function () {
    let orderVAl = jQuery(this).data("sort-value");
    jQuery(this).parent().removeClass("is-active");
    let formData = ourArtistInstance.defaultFilters;
    formData["order"] = orderVAl;
    ourArtistInstance.getArtists(formData);
  });
});

// End our artist page js

// Manage reserve product button on variation page
jQuery(document).on("hide_reserve_button", function () {
  jQuery(".js-reserve-product-btn").hide();
});
jQuery(document).on("show_reserve_button", function () {
  jQuery(".js-reserve-product-btn").show();
});
jQuery(".single_variation_wrap").on(
  "show_variation",
  function (event, variation) {
    // if price not coming
    if (
      typeof variation.display_price == "undefined" ||
      !parseFloat(variation.display_price)
    ) {
      jQuery(document).trigger("hide_reserve_button");
    } else if (parseFloat(variation.display_price) <= 500) {
      jQuery(document).trigger("hide_reserve_button");
    } else {
      jQuery(document).trigger("show_reserve_button");
    }
  }
);
// End Manage reserve product button on variation page

// Custom gift card form integration

jQuery(document).on("wagt_gift_card_applied", function () {
  if (jQuery("body").hasClass("woocommerce-cart")) {
    // trigger cart fragments
    jQuery(document.body).trigger("wc_update_cart");
    jQuery(document.body).trigger("update_checkout");
  }

  if (jQuery("body").hasClass("woocommerce-checkout")) {
    // trigger checkout fragments
    jQuery(document.body).trigger("update_checkout");
  }

  // trigger original event attached in gift card plugin file
  jQuery(document.body).trigger("updated_wc_div");
  jQuery(document.body).trigger("wc_fragment_refresh");
});

// Custom Trigger on apply Gift card

jQuery(function () {
  jQuery("#pwgc-redeem-form")
    .off("submit.pimwick")
    .on("submit.pimwick", function (e) {
      pwgc_checkout_redeem_gift_card(jQuery("#pwgc-redeem-button"));
      e.preventDefault();
      return false;
    });
});

jQuery(document).on("submit", ".js-custom-gift-form", function (e) {
  e.preventDefault();

  const form = jQuery(this);
  const button = form.find(".js-custom-gift-form-button");
  const input = form.find(".js-custom-gift-form-input");
  const errorContainer = form.find(".js-gift-card-error");

  function resetError() {
    form.removeClass("has-error");
    errorContainer
      .text("")
      .removeClass("woocommerce-success woocommerce-error");
  }

  function setError(text, success = false) {
    form.addClass("has-error");
    errorContainer
      .text(text)
      .addClass(success ? "woocommerce-success" : "woocommerce-error");
  }

  function toggleLoading(isLoading) {
    if (isLoading === true) {
      form.addClass("is-loading");
      button.prop("disabled", true);
    } else {
      form.removeClass("is-loading");
      button.prop("disabled", false);
    }
  }

  resetError();
  toggleLoading(true);

  if (typeof pwgc == "undefined" || pwgc == null || !Object.keys(pwgc).length) {
    setError(
      "We could not able to get gift card plugin variables and events. Please double check"
    );
    console.log(
      "We could not able to get gift card plugin variables and events. Please double check"
    );
    toggleLoading(false);
    return;
  }

  jQuery
    .post(
      pwgc.ajaxurl,
      {
        action: "pw-gift-cards-redeem",
        card_number: jQuery("#wagt-redeem-gift-card-number").val(),
        security: pwgc.nonces.apply_gift_card,
      },
      function (result) {
        toggleLoading(false);

        if (result.success) {
          form[0].reset();
          setError(wagt_gift_error_codes.gift_card_applied, true);

          setTimeout(function () {
            // trigger custom trigger to update fragments and all
            jQuery(document.body).trigger("wagt_gift_card_applied");
          }, 1000);
        } else {
          setError(result.data.message);
          input.focus();
        }
      }
    )
    .fail(function (xhr, textStatus, errorThrown) {
      if (errorThrown) {
        setError(errorThrown);
      } else {
        setError("Unknown Error");
      }

      toggleLoading(false);
      input.focus();
    });

  return false;
});

//  End Custom gift card form integration

/**
 *
 * @param input
 * @param valueMissingMsg
 * wagtSetCustomValidity
 */
function wagtSetCustomValidity(input, valueMissingMsg) {
  let final_valueMissingMsg = "This field is required.";
  if (typeof valueMissingMsg != "undefined" && !valueMissingMsg) {
    final_valueMissingMsg = valueMissingMsg;
  }
  let validityState = input.validity;
  if (validityState.valueMissing) {
    input.setCustomValidity(final_valueMissingMsg);
  } else {
    input.setCustomValidity("");
  }
  input.reportValidity();
}

// Manage custom product request form
function showProductRequestStepOne() {
  jQuery('.js-form-preloader').hide();
  jQuery(".js-product-request-step-2-content").hide();
  jQuery(".js-product-request-step-1-content").show();
}

function showProductRequestStepTwo() {
  jQuery(".js-product-request-step-1-content").hide();
  jQuery(".js-product-request-step-2-content").show();
}

function showProductRequestStepThree() {
  jQuery(".js-product-request-step-2-content").hide();
  jQuery(".js-product-request-step-3-content").show();
}

jQuery('.js-step-go-step-2').on('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  showProductRequestStepOne();
});

function submitProductRequestForm(that) {
  event.preventDefault();
  let formEl = jQuery(that);
  let submitBtnEl = formEl.find('button[type="submit"]');
  let preloaderEl = submitBtnEl.find(".js-preloader-text");
  let formPreloaderEl = formEl.find(".js-form-preloader");
  let modalEl = jQuery("#wagt-product-request-popup-step-1");
  let appointmentFormId = "#popup-appointment";
  let formData = new FormData(that);
  jQuery.ajax({
    url: wagt_ajax_url,
    type: "POST",
    data: formData,
    cache: false,
    contentType: false,
    processData: false,
    beforeSend: function () {
      // set preloader msg and
      formPreloaderEl.removeClass("text-danger text-success").hide();
      preloaderEl.text(submitBtnEl.data("preloader-text"));
    },
    success: function (res) {
      submitBtnEl
        .find(".js-preloader-text")
        .text(submitBtnEl.data("button-text"));
      if (res.succ) {
        formPreloaderEl.addClass("text-success");
        formPreloaderEl.html(res.msg).show();

        // do reset form
        formEl.trigger("reset");
        formEl.find(".js-product_file").val("").trigger("change");

        // check show appointment form
        if (
          typeof res.show_appointment_form != "undefined" &&
          res.show_appointment_form
        ) {
          modalEl
            .find('span[data-fancybox-close="data-fancybox-close"]')
            .eq(0)
            .trigger("click");
          // show appointment form

          Fancybox.show([{ src: appointmentFormId, type: "inline", click: null }]);
        } else {
            showProductRequestStepThree();
        }
      } else {
        formPreloaderEl.addClass("text-danger");
        formPreloaderEl.html(res.errors_string).show();
      }
    },
  });
}

jQuery('#js-product-request-form-step-1').on('submit', function(event) {
  event.preventDefault();
  submitProductRequestForm(this);
})

jQuery(document).on(
  "click",
  ".js-proceed-to-step-2-product-request",
  function () {
    // do validate first step content
    event.preventDefault();

    let my_desireEl = document.querySelector("textarea[name=my_desire]");
    let my_reff_and_measurementEl = document.querySelector(
      "textarea[name=my_reff_and_measurement]"
    );
    let product_fileEl = document.querySelector("#product_file");
    let hasErrorInStepOne = false;
    // check validation step 1
    if (typeof my_desireEl.value == "undefined" || !my_desireEl.value) {
      wagtSetCustomValidity(my_desireEl);
      hasErrorInStepOne = true;
      return false;
    }

    if (
      typeof my_reff_and_measurementEl.value == "undefined" ||
      !my_reff_and_measurementEl.value
    ) {
      wagtSetCustomValidity(my_reff_and_measurementEl);
      hasErrorInStepOne = true;
      return false;
    }

    if (typeof product_fileEl.value == "undefined" || !product_fileEl.value) {
      wagtSetCustomValidity(product_fileEl);
      hasErrorInStepOne = true;
      return false;
    }
    // if we found any error then do not proceed to second step
    if (hasErrorInStepOne) {
      return false;
    } else {
      showProductRequestStepTwo();
    }
  }
);

jQuery(document).on(
  "click",
  ".js-wagt-show-product-request-popup",
  function () {
    showProductRequestStepOne();
    Fancybox.show([
      { src: "#wagt-product-request-popup-step-1", type: "inline" },
    ]);
  }
);

jQuery(document).on("drag drop change", ".js-product_file", function () {
  let thisVal = jQuery(this).val();
  let fileMsg = jQuery(".js-product-file-selected");
  fileMsg.html("").hide();
  if (thisVal) {
    // show file msg
    fileMsg.html(thisVal).show();
  }
});

// End Manage custom product request form

// Manage add to cart hide and show event
jQuery(document).on(
  "added_to_cart",
  function (event, fragments, cart_hash, thisButton) {
    if (jQuery("body").hasClass("single-artist-category")) {
      jQuery(thisButton).hide();
    }
    let inCartClasses = "wagt-product-not-in-cart wagt-product-in-cart";
    let inCartAddedToCartClass = "wagt-product-in-cart";
    let manageInCartEl = jQuery(thisButton).closest(".wagt-js-manage-in-cart");

    // if manage class is found
    if (manageInCartEl.length) {
      // do hide add to cart button in my art goes boom
      if (manageInCartEl.hasClass("art-card")) {
        manageInCartEl
          .removeClass(inCartClasses)
          .addClass(inCartAddedToCartClass);
      }
      // End do hide add to cart button in my art goes boom
    }
  }
);
// End manage add to cart hide and show event

// In Side cart- Remove item from cart

jQuery(document).on(
  "removed_from_cart",
  function (event, fragments, cart_hash, thisbutton) {
    let thisButtonEl = jQuery(thisbutton);
    let removedProductID = thisbutton.data("product_id");
    // manage events on single artist category page
    if (jQuery("body").hasClass("single-artist-category")) {
      let inCartClasses = "wagt-product-not-in-cart wagt-product-in-cart";
      let notInCartClass = "wagt-product-not-in-cart addedClassAfterRemove";
      let artCardProductBtn = jQuery(document)
        .find(".my-art-boom-wrap__right_content")
        .find("a[data-product_id='" + removedProductID + "']");
      if (artCardProductBtn.length) {
        artCardProductBtn.removeAttr("style"); // remove style prop:because display none is coming after added to cart
        artCardProductBtn.removeClass("added"); // remove class added
        artCardProductBtn
          .parents(".art-card")
          .removeClass(inCartClasses)
          .addClass(notInCartClass);
      }
    }
  }
);

// Manage hide and show on cart page after remove from cart

function manage_hide_and_show_after_item_remove_from_cart() {
  let haveRestoreItemEl = jQuery(document).find(
    ".woocommerce-notices-wrapper .restore-item"
  );
  if (haveRestoreItemEl.length) {
    haveRestoreItemEl.parents(".woocommerce-message").hide();
  }
}

jQuery(document).on("wc_cart_emptied", function () {
  manage_hide_and_show_after_item_remove_from_cart();
  triggerCartPageGiftCardMsgInput();
});
jQuery(document).on("updated_wc_div", function () {
  manage_hide_and_show_after_item_remove_from_cart();
  triggerCartPageGiftCardMsgInput();
});
// End Manage hide and show on cart page after remove from cart

// Global Bookly event bind with a tag
jQuery(document).on(
  "click",
  'a[href="#js-show-bookly-form-popup"]',
  function () {
    event.preventDefault();
    Fancybox.show([{ src: "#popup-appointment", type: "inline", click: null }]);
  }
);
// End Global Bookly event bind with a tag

// End  cart gift card check box event

// my account manage alerts
jQuery(function () {
  // check is my account
  if (!jQuery("body").hasClass("woocommerce-account")) {
    return false;
  }
  // also check if page is my account and current page is my alert
  let myaccountUrlPath = window.location.pathname.split("/");
  if (typeof myaccountUrlPath[2] == "undefined" || !myaccountUrlPath[2]) {
    return false;
  }

  if (myaccountUrlPath[2] != "alerts") {
    return false;
  }

  myAccAlerts = {
    myAlertsWrap: jQuery(".js-wagt-my-alerts"),
    myAccAristsWrap: jQuery(".js-my-account-artists"),
    myAlertsNoResultsWrap: jQuery(".js-wagt-my-alerts-no-results"),
    fetchArtistList: function () {
      let ajaxData = {
        action: 'sf_artists_get_all_registrations',
        email: myAccAlerts.myAccAristsWrap.data('user-email')
      };

      jQuery.ajax({
        type: "post",
        url: wc_add_to_cart_params.ajax_url,
        data: ajaxData,
        success: function (response) {
          myAccAlerts.myAccAristsWrap.html(response);
          myAccAlerts.initRemoveBtns();
        },
      });
    },
    initRemoveBtns() {
      jQuery('.js-remove-alerts').on('click', function(e) {
        let data = {
          action: 'sf_artists_unregister',
          entity_id: jQuery(this).data('artist-id'),
          email: myAccAlerts.myAccAristsWrap.data('user-email')
        };

        let $element = jQuery(this);

        jQuery.ajax({
          type: "post",
          url: wc_add_to_cart_params.ajax_url,
          data: data,
          success: function (response) {
            $element.parents('.artist-card').remove();
          },
        });
      })
    }
    // fetchMyalerts: function () {
    //   let ajaxData = {};
    //   ajaxData["action"] = "wagt_myaccount_my_alerts";
    //   jQuery.ajax({
    //     type: "post",
    //     url: wc_add_to_cart_params.ajax_url,
    //     data: ajaxData,
    //     beforeSend: function () {
    //       // site_preloader_on();
    //     },
    //     success: function (response) {
    //       // site_preloader_off();
    //       if (response.succ) {
    //         myAccAlerts.myAlertsNoResultsWrap.hide();
    //         myAccAlerts.myAlertsWrap.html(response.html);
    //       } else {
    //         // make empty old data
    //         myAccAlerts.myAlertsWrap.html("");
    //         // show no results wrap
    //         myAccAlerts.myAlertsNoResultsWrap.show();
    //       }
    //     },
    //   });
    // },
  };

  // on ready state get my alerts
  // myAccAlerts.fetchMyalerts();

  // fetch artists on ready state
  myAccAlerts.fetchArtistList();
});

// end my account manage alerts

function pictureWithTooltips() {
  const buttonSelector = ".js-picture-tooltip-button";
  const containerSelector = ".js-picture-tooltip-container";

  if (jQuery(buttonSelector).length === 0) {
    return;
  }

  jQuery(document).on("click", buttonSelector, function () {
    jQuery(this).closest(containerSelector).toggleClass("is-active");
  });

  jQuery(document).on("click", containerSelector, function (e) {
    e.stopPropagation();
    const container = jQuery(this);

    function hideOnClickOutsideFunction(e) {
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("is-active");
        jQuery(document).off("mouseup", hideOnClickOutsideFunction);
      }
    }

    jQuery(document).on("mouseup", hideOnClickOutsideFunction);
  });
}

setTimeout(pictureWithTooltips, 0);



// Manage theme notification
jQuery(document).on("click", ".js-noti-read", function () {
  // setCookie("is_noti_read", true, 1);
  // jQuery(this)
  //   .parents(".header__notifications")
  //   .find(".header-notifications__item")
  //   .remove("header-notifications__item_new");
});

// manage notification click event in header
jQuery(document).on("click", ".js-notification-dropdown-toggle", function () {
  event.preventDefault();
  jQuery(this).toggleClass("is-active");
});

jQuery(document).on("click", ".js-read-notification", function () {
  event.preventDefault();
  let notification_id = jQuery(this).data("notification-id");
  let redirect = jQuery(this).data("redirect");
  if (typeof notification_id == "undefined" || !parseInt(notification_id)) {
    return false;
  }

  jQuery.ajax({
    type: "POST",
    url: wc_add_to_cart_params.ajax_url,
    data: {
      action: "wagt_mark_notification_read",
      notification_id: notification_id,
    },
    success: function (response) {
      if (response.succ) {
        // if we redirect then do redirect else skip
        if (typeof redirect != "undefined" && redirect != "") {
          window.location.href = redirect;
        }
      } else {
        // here show error or do not process anythings
        return false;
      }
    },
  });
});


if(jQuery('.btn-readmore').length > 0) {
  jQuery('.btn-readmore').on('click', function() {
    jQuery(this).parents('.readmore').toggleClass('show');
  });
}

if(jQuery('#cart-login').length > 0) {
  jQuery('#cart-login').on('submit', loginAjax);

  /* ================================
  * Ajax login handler
  * ================================ */
  function loginAjax(e) {
    jQuery.ajax({
      type: 'POST',
      dataType: 'json',
      url: window['wagt_ajax_url'],
      data: {
        action: 'ajaxlogin', // calls wp_ajax_nopriv_ajaxlogin
        username: jQuery('#cart-login #username').val(),
        password: jQuery('#cart-login #password').val(),
        security: jQuery('#cart-login #security').val(),
        redirect: jQuery('#cart-login #redirect').val(),
      },
      success: function(data) {
        if (data.loggedin === true) {
          jQuery('.success-login').text(data.message);
          jQuery('.wrong-login').hide();
          jQuery('.success-login').show();

          // redirect to checkout after loggin
          window.location.href = data.redirect;
        }
        // Error
        else {
          jQuery('.wrong-login').text(data.message)
          jQuery('.wrong-login').show();
        }
      }
    });

    e.preventDefault();
  }
}